import {AxoisRequestManager} from "../../stores/managers/RequestManager";
import {from} from "rxjs";
import type SitApi from "../SitApit";
import {makeAutoObservable} from "mobx";
import type {AuditLogDetail, AuditLogEntry} from "../ApiTypes";

export class AuditLogStore {
    readonly initiativeAuditLogRM = new AxoisRequestManager<{id: number}, AuditLogEntry[]>(
        ({id}) => from(this.api.initiativeAuditLog(id)));

    readonly targetAuditLogRM = new AxoisRequestManager<{id: number}, AuditLogEntry[]>(
        ({id}) => from(this.api.targetAuditLog(id)));

    // ADMIN-only; 403s for anyone else (surfaced via .error on this manager).
    readonly auditLogDetailRM = new AxoisRequestManager<{id: number}, AuditLogDetail>(
        ({id}) => from(this.api.auditLogDetail(id)));

    constructor(private api: SitApi) {
        makeAutoObservable(this, {});
    }
}
